export var ZeroEtlTargetTableStatus;
(function (ZeroEtlTargetTableStatus) {
    ZeroEtlTargetTableStatus["ZERO_ETL_TARGET_TABLE_RUNNING"] = "RUNNING";
    ZeroEtlTargetTableStatus["ZERO_ETL_TARGET_TABLE_COMPLETED"] = "COMPLETED";
    ZeroEtlTargetTableStatus["ZERO_ETL_TARGET_TABLE_PARTIAL"] = "PARTIAL";
    ZeroEtlTargetTableStatus["ZERO_ETL_TARGET_TABLE_FAILED"] = "FAILED";
})(ZeroEtlTargetTableStatus || (ZeroEtlTargetTableStatus = {}));
